import { render, staticRenderFns } from "./MailAddressAdded.vue?vue&type=template&id=e93873f6&scoped=true"
import script from "./MailAddressAdded.vue?vue&type=script&lang=js"
export * from "./MailAddressAdded.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e93873f6",
  null
  
)

export default component.exports